import React, { memo } from "react";
import { useTranslation } from "react-i18next";

interface MapErrorStateProps {
  error: string;
}

const MapErrorState: React.FC<MapErrorStateProps> = memo(({ error }) => {
  const { t } = useTranslation();
  return (
    <div className="map-container">
      <div className="map-placeholder">
        <h2>{t("map.mapError")}</h2>
        <p>{error}</p>
        <p>
          {t("map.mapErrorDetails")}
        </p>
      </div>
    </div>
  );
});

MapErrorState.displayName = "MapErrorState";

export default MapErrorState;
